import { DOCUMENT } from '@angular/common';
import { ChangeDetectionStrategy, Component, effect, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ReactiveFormsModule } from '@angular/forms';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';
import { ToasterComponent } from '@lbca-shared/toaster';
import { filter, map } from 'rxjs';

/** Telas de contratos, inclusive o Portal Externo, que usa outro layout. */
const CONTRACTS_URL_PREFIXES = ['/products/contracts', '/tributario/contracts', '/portal'];
/**
 * Base de fonte maior nas telas de contratos (padrão do protótipo: 16px). Como o Tailwind trabalha
 * em rem, tudo cresce por igual — texto, botões, badges, tabelas —, como um zoom só neste módulo.
 */
const CONTRACTS_BASE_FONT_SIZE = '17px';

@Component({
	selector: 'lbca-app-root',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [ReactiveFormsModule, RouterOutlet, ToasterComponent],
	template: `
		<lbca-toaster />
		<router-outlet />
	`,
})
export class App {
	readonly #document = inject(DOCUMENT);
	readonly #router = inject(Router);

	readonly #url = toSignal(
		this.#router.events.pipe(
			filter((event) => event instanceof NavigationEnd),
			map((event) => event.urlAfterRedirects),
		),
		{ initialValue: this.#router.url },
	);

	constructor() {
		// `styles.css` lê `--base-font-size` no <html>; fora de contratos a variável sai e volta o padrão.
		effect(() => {
			const url = this.#url();
			const rootStyle = this.#document.documentElement.style;
			if (CONTRACTS_URL_PREFIXES.some((prefix) => url.startsWith(prefix))) {
				rootStyle.setProperty('--base-font-size', CONTRACTS_BASE_FONT_SIZE);
			} else {
				rootStyle.removeProperty('--base-font-size');
			}
		});
	}
}
